import { Stack, Text } from "@mantine/core"
import {
  CommunicationStudioClasses,
  CUSTOMISATION_CATEGORIES,
} from "@tfg/types/constants/communication-studio.constant"
import {
  textColorCssVariable,
  textFontSizeCSSVariable,
  textFontWeightCSSVariable,
} from "@tfg/types/schemas/communication-studio/cssVariables"

import { useGetStylingParametersContext } from "../context/stylingParameters/useGetStylingParametersContext"
import { useGetTranslationsContext } from "../context/translationsContext/useGetTranslationsContext"
import { DesignStudioParametersToolkit } from "../utils/designStudioParametersToolkit"

export function Scan4ChemAGEC() {
  const { t } = useGetTranslationsContext()
  const { stylingParameters } = useGetStylingParametersContext()
  if (!stylingParameters) return null

  return (
    <Stack w="100%">
      <Stack justify="center" align="center">
        <Text
          w="100%"
          c={DesignStudioParametersToolkit.getCssVariableLiteralName(
            textColorCssVariable
          )}
          fz={DesignStudioParametersToolkit.getCssVariableLiteralName(
            textFontSizeCSSVariable
          )}
          fw={DesignStudioParametersToolkit.getCssVariableLiteralName(
            textFontWeightCSSVariable
          )}
          style={DesignStudioParametersToolkit.spreadStylingParameters({
            category: CUSTOMISATION_CATEGORIES.GLOBAL,
            stylingParameters,
            stylingParamKeys: ["letterSpacing"],
          })}
        >
          {t("other.paragraph3")}
          <a
            className={CommunicationStudioClasses.PACKAGING_INFO_HYPER_LINK}
            style={{
              fontWeight:
                DesignStudioParametersToolkit.getCssVariableLiteralName(
                  textFontWeightCSSVariable
                ),
              fontSize: DesignStudioParametersToolkit.getCssVariableLiteralName(
                textFontSizeCSSVariable
              ),
            }}
            href="https://www.askreach.eu/app/"
            target="_blank"
            rel="noreferrer"
          >
            Scan4Chem
          </a>
        </Text>
      </Stack>
    </Stack>
  )
}
